import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Input, Col, Button, Card, Form,
} from 'antd';
import { Link } from 'react-router-dom';
import { addGroup } from '../redux/actions/add_group.actions';
import { validation_rules } from '../../../../shared/validation_rules';

const FormItem = Form.Item;

export default connect()(class User_group_create_table extends PureComponent {
  state = {
      name: '',
      abbr: '',
      description: '',
  };

  getInputValueHandler = event => this.setState({ [event.target.name]: event.target.value });

  handleSubmit = () => this.props.dispatch(addGroup(this.state));

  render() {
      const isDisabled = Object.keys(this.state).some(field => !this.state[field].length);
      const { isValueExist } = validation_rules;
      return (
          <Col span={12}>
              <Card>
                  <Form>
                      <FormItem style={{ marginTop: 20 }} label="Name">
                          <Input
                              maxLength={20}
                              autoComplete="off"
                              name="name"
                              placeholder="Enter group name"
                              onChange={this.getInputValueHandler}
                          />
                          <span className="createUserValidationError">
                              {isValueExist(this.state.name)}
                          </span>
                      </FormItem>
                      <FormItem style={{ marginTop: 20 }} label="Abbreviation">
                          <Input
                              maxLength={5}
                              autoComplete="off"
                              name="abbr"
                              placeholder="Enter group abbreviation"
                              onChange={this.getInputValueHandler}
                          />
                          <span className="createUserValidationError">
                              {isValueExist(this.state.abbr)}
                          </span>
                      </FormItem>
                      <FormItem style={{ marginTop: 20 }} label="Description">
                          <Input.TextArea
                              maxLength={200}
                              name="description"
                              placeholder="Describe the group"
                              onChange={this.getInputValueHandler}
                          />
                          <span className="createUserValidationError">
                              {isValueExist(this.state.description)}
                          </span>
                      </FormItem>
                      <div style={{ float: 'right', marginTop: 20 }}>
                          <Link to="/UserManagement/User_group/">
                              <Button>Back to groups</Button>
                          </Link>
                          <Button
                              type="primary"
                              disabled={isDisabled}
                              style={{ marginLeft: 10 }}
                              onClick={this.handleSubmit}
                          >
                              Add Group
                          </Button>
                      </div>
                  </Form>
              </Card>
          </Col>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/components/User_group_create_table.js